import React, { useState, Fragment } from 'react';
import { Transition } from '@headlessui/react';

const Tooltip = ({ children, content, position = 'bottom' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const positionClasses = {
    top: 'bottom-full mb-2',
    bottom: 'top-full mt-2',
  };

  const arrowClasses = {
    top: 'bottom-[-4px] border-t-gray-900 rotate-180',
    bottom: 'top-[-4px] border-t-gray-900',
  };

  return (
    <div className="relative">
      <div
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {children}
      </div>
      <Transition
        show={isOpen}
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div className={`absolute left-1/2 transform -translate-x-1/2 ${positionClasses[position]} px-2 py-1 bg-gray-900 text-white text-sm rounded-md whitespace-nowrap z-[60]`}>
          {content}
          <div className={`absolute left-1/2 transform -translate-x-1/2 ${arrowClasses[position]}`}>
            <div className="border-4 border-transparent"></div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default Tooltip; 